var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-partners-list"},_vm._l((_vm.items),function(item,index){return _c('a',{key:index,attrs:{"href":item.link,"target":"_blank"}},[_c('img',{attrs:{"alt":"Partner logo","src":item.url.data.attributes.url}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }